// extracted by mini-css-extract-plugin
export var container = "ready-to-become-astronaut-section-module--container--w8eA2";
export var video = "ready-to-become-astronaut-section-module--video--hQUP5";
export var content = "ready-to-become-astronaut-section-module--content--Bi4MU";
export var title = "ready-to-become-astronaut-section-module--title--BVPX6";